import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { AuthenticationService } from "./authentication.service";

@Injectable({
  providedIn: "root"
})
export class AuthGuardService implements CanActivate{
  constructor(private _authService: AuthenticationService){

  }
  canActivate(): Promise<boolean>{
    return new Promise((resolve) => {
      this._authService.isLoggedInPromise().then(loggedIn => {
        if (loggedIn){
          resolve(true);
        }
        else{
          this._authService.login();
          resolve(false);
        }
      })
    });
  }
}